import React, {useEffect} from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { FiSettings } from 'react-icons/fi';
import { TooltipComponent } from '@syncfusion/ej2-react-popups';

import { Navbar, Footer, Sidebar, ThemeSettings } from '../components';
import { RegistroClientes, Comunas, Tickets, Clientes,Dropoffs,  
  ReporteRecolectores, RegistroRecepcion, Ayuda,ReporteRecolectoresPartner,
  RegistroClientePartner, 
  RegistroSalidas, ReportePagos, RegistroPagos, RegistroRutas, CentrosCompostaje, Usuarios,
  Recolectores, PlanesSuscripcion, Parametros, PlanesServiciosInfo, PlanesServicios, HistorialPagosCliente } from '../pages';
import DashboardN from '../pages/Dashboard/DashboardN';	
import  DashboardNClientes from '../pages/Dashboard/DashboardNClientes';	
import  DashboardNDropoff from '../pages/Dashboard/DashboardNDropoff';	
import  DashboardNPartners from '../pages/Dashboard/DashboardNPartners';	



import Login from '../pages/Login';

import  {fetchUser}  from '../utils/fetchUser';

import '../App.css';
import { useStateContext } from '../contexts/ContextProvider';

const Home = () => {
    const {currentMode, setCurrentColor, setCurrentMode, activeMenu, currentColor, themeSettings, setThemeSettings } = useStateContext();
    const navigate = useNavigate();
    const User = fetchUser();

    useEffect(() => {
      if (!User) navigate('/login');
    }, []);
  

    useEffect(() => {
        const currentThemeColor = localStorage.getItem('colorMode');
        const currentThemeMode = localStorage.getItem('themeMode');
        if (currentThemeColor && currentThemeMode) {
        setCurrentColor(currentThemeColor);
        setCurrentMode(currentThemeMode);
        }
    }, []);
  
    return (
      <div className={currentMode === 'Dark' ? 'dark' : ''}>
        <div className="flex relative dark:bg-main-dark-bg">
        {/*   <div className="fixed right-4 bottom-4" style={{ zIndex: '1000' }}>
            <TooltipComponent
              content="Settings"
              position="Top"
            >
              <button
                type="button"
                onClick={() => setThemeSettings(true)}
                style={{ background: currentColor, borderRadius: '50%' }}
                className="text-xs text-white p-3 hover:drop-shadow-xl hover:bg-light-gray"
              >
                <FiSettings />
              </button>
  
            </TooltipComponent>
          </div>
        */}
        {activeMenu ? (
          <div className="w-72 fixed sidebar dark:bg-secondary-dark-bg bg-white ">
            <Sidebar />
          </div>
        ) : (
          <div className="w-0 dark:bg-secondary-dark-bg">
            <Sidebar />
          </div>
        )}
        <div
          className={
            activeMenu
              ? 'dark:bg-main-dark-bg  bg-main-bg min-h-screen md:ml-72 w-full  '
              : 'bg-main-bg dark:bg-main-dark-bg  w-full min-h-screen flex-2 '
          }
        >
            <div className="fixed md:static bg-main-bg dark:bg-main-dark-bg navbar w-full ">
              <Navbar />
            </div>
          <div>
  
          {themeSettings && (<ThemeSettings />)}
  
              <Routes>
                {/* dashboard  */}
                <Route path="/login" element={(<Login />)} />

                <Route path="/*" element={(
                    User && User.rol === 'Cliente' ? <DashboardNClientes />
                  : User && User.rol === 'Drop-off' ? <DashboardNDropoff />
                  : User && User.rol === 'Partner' ? <DashboardNPartners />
                  : User && User.rol === 'Administrador' ? <DashboardN />
                  : <DashboardN />
                  )} />
                <Route path="/Mi Biopanel" element={(
                    User && User.rol === 'Cliente' ? <DashboardNClientes />
                  : User && User.rol === 'Drop-off' ? <DashboardNDropoff />
                  : User && User.rol === 'Partner' ? <DashboardNPartners />
                  : User && User.rol === 'Administrador' ? <DashboardN />
                  : <DashboardN />
                )}  />
                
                {/* pages  */}
                <Route path="/clientes" element={<Clientes />} />
                <Route path="/comunas" element={<Comunas />} />
                <Route path="/planes suscripción" element={<PlanesSuscripcion />} />
                <Route path="/partners" element={<Recolectores />} />
                <Route path="/puntos drop off" element={<Dropoffs />} />

                <Route path="/centros compostaje" element={<CentrosCompostaje />} />
                <Route path="/retiros por partner" element={<ReporteRecolectores />} />
                <Route path="/reporte pagos" element={<ReportePagos />} />
                <Route path="/registro recepción" element={<RegistroRecepcion />} />
                <Route path="/registro salidas" element={<RegistroSalidas />} />
                <Route path="/registro pagos" element={<RegistroPagos />} />
                <Route path="/programar rutas" element={<RegistroRutas />} />
                <Route path="/retiros" element={<ReporteRecolectoresPartner />} />

                <Route path="/planes y servicios" element={<PlanesServicios />} />
                <Route path="/información planes" element={<PlanesServiciosInfo />} />

                <Route path="/pagos" element={<HistorialPagosCliente />} />
                <Route path="/ayuda" element={<Ayuda />} />

                <Route path="/solicitudes" element={<Tickets />} />
 
                {/* apps  */}
                <Route path="/usuarios" element={<Usuarios />} />
                <Route path="/proveedores" element={<Clientes />} />
                <Route path="/registro clientes" element={<RegistroClientes />} />
                <Route path="/registrar cliente" element={<RegistroClientePartner />} />
                <Route path="/parametros" element={<Parametros />} />
  
              </Routes>
            </div>
            <Footer />
          </div>
        </div>
    
      </div>
    );

}

export default Home;